<template>
  <div :class="className" :style="{bgColor,'margin':margin}">
    <img
      :src="icon"
      style="
          display: inline-block;
          float: left;
          position: absolute;
          width: 14px;
          height: 14px;
          color: #ffffff;
          margin: 3px 4px 0 3px;
        "
    />
    <div class="desc" style="margin-left: 20px">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import blueIcon from "@/assets/images/new_icon_reminder.png"
import yellowIcon from "@/assets/images/new_icon_waring_yellow.png"
let types = {
  "blue": "tipBg",
  "yellow": "topTis"
}
let iconUrl = {
  "blue": blueIcon,
  "yellow": yellowIcon
}
export default {
  components: {},
  props: {
    type: {
      type: String,
      default: "blue"
    },
    margin: {
      type: String,
      default: "30px"
    }
  },
  data() {
    return {};
  },
  computed: {
    className() {
      return types[this.type]
    },
    icon() {
      return iconUrl[this.type]
    },
    bgColor() {
      if(this.type==="blue") {
        return "background:#f4f7ff;"
      } else if(this.type==="yellow") {
        return "background:#fffaee;"
      }
    }
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
    .topTis,.tipBg {
      display: flex;
      align-items: baseline;
      color: #333;
      font-size: 14px;
      padding: 12px;
      color: #333;
      .desc {
        line-height: 20px;
        .setting-text {
          margin-bottom: 8px;
          span {
            font-size: 14px;
            color: #7b61ff;
            margin-left: 30px;
          }
        }
      }
      p,div {
        margin-left: 5px;
        line-height: 20px;
      }
    }
</style>
